import EmptyState from 'components/EmptyState';
import IconText from 'components/IconText';
import Currency from 'components/Pricing/components/Currency';
import Typography from 'components/Typography';
import {
  PAYMENT_FREQUENCY_MAP,
  PRICING_MODEL_ENUM,
  PRICING_MODEL_MAP,
} from 'helpers/dataTransformers/pricing';
import { thousandSeparator } from 'helpers/formatters';

import icPricetagSVG from 'assets/ic-pricetag.svg';

import classes from './PricingDisplay.module.scss';

const formatPrice = (value) => {
  if (value === 0) return '0.00';
  return value > 1000 ? thousandSeparator(value) : value.toString();
};
const PricingDisplay = ({ plan, hidePricingModel }) => {
  const price = Number(plan.startingPrice) ?? 0;

  const showPricingModel =
    !hidePricingModel &&
    PRICING_MODEL_MAP[plan?.pricingModel] &&
    PRICING_MODEL_MAP[plan?.pricingModel]?.text;

  return (
    <div>
      {plan?.priceType === 1 ? (
        <>
          <div className={classes.pricing}>
            <Currency pricing={plan} />
            <div className={classes.priceAndModel}>
              <Typography variant="display-sm">{formatPrice(price)}</Typography>
              {plan.pricingModel === PRICING_MODEL_ENUM.perUser && (
                <Typography variant="body-xs" className={classes.subscript}>
                  /user
                </Typography>
              )}
            </div>
          </div>
          {price !== 0 && (
            <div className={classes.iconsSection}>
              {plan.paymentFrequency && (
                <IconText
                  className={classes.iconText}
                  icon={['far', 'calendar']}
                  text={PAYMENT_FREQUENCY_MAP[plan.paymentFrequency]}
                  variant="small"
                />
              )}
              {showPricingModel && (
                <IconText
                  className={classes.iconText}
                  icon={PRICING_MODEL_MAP[plan.pricingModel]?.icon}
                  text={PRICING_MODEL_MAP[plan.pricingModel]?.text}
                  variant="small"
                />
              )}
            </div>
          )}
        </>
      ) : typeof plan?.customPrice === 'string' && plan.customPrice.trim() ? (
        <Typography variant="heading-sm">{plan.customPrice}</Typography>
      ) : (
        <EmptyState
          img={icPricetagSVG.src}
          text="No pricing info"
          variant="small"
        />
      )}
    </div>
  );
};

export default PricingDisplay;
